import { Modal } from '@maxtropy/components';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import React, { Key, useEffect, useState } from 'react';
import styles from './index.module.scss';
import { DragOutlined, MenuOutlined } from '@ant-design/icons';
import {
  apiV2WorkCenterSequencePost,
  apiV2EnergyConsumptionEvaluationAnalysisUnitEnergyUnitSortPost,
} from '@maxtropy/device-customer-apis-v2';

interface Props {
  ok?: () => void;
  cancel?: () => void;
  modelTitle?: string;
  sortData?: any[];
}

interface CenterItem {
  id: Key;
  name: string;
}

const UnitSortModal: React.FC<Props> = ({ cancel, ok, modelTitle, sortData = [] }) => {
  const [data, setData] = useState<CenterItem[]>([]);

  useEffect(() => {
    // 当siblingNodes变化时，更新内部状态
    setData(
      sortData?.map(node => ({
        id: node.id,
        name: node.name,
      }))
    );
  }, [sortData]);

  const handleOnDragEnd = (result: any) => {
    if (!result.destination) return;

    const items = Array.from(data);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setData(items);
  };

  const submit = () => {
    const list = data.map((item, index) => ({ id: item.id as number, sequence: index + 1 }));
    apiV2EnergyConsumptionEvaluationAnalysisUnitEnergyUnitSortPost({ sortDetailList: list }).then(() => {
      ok?.();
    });
  };

  return (
    <Modal title={modelTitle} open={true} onCancel={cancel} onOk={submit} destroyOnClose>
      <div className={styles.wrapper}>
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId="menus" direction="vertical">
            {provided => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {data.map((item: any, index: number) => (
                  <Draggable key={item.id} draggableId={String(item.id)} index={index}>
                    {provided => (
                      <div ref={provided.innerRef} {...provided.draggableProps} className={styles.itemWrapper}>
                        <div {...provided.dragHandleProps} className={styles.item}>
                          <MenuOutlined className={styles.icon} />
                          {item.name}
                          <DragOutlined className={styles.drag} />
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </Modal>
  );
};

export default UnitSortModal;
